import React, { useRef, useEffect, useState } from "react";
import "./FeaturedProperties.css";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import api from "../../Api.js";

const PremiumFeaturedListings = () => {
  const scrollRef = useRef(null);
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 992);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 992);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const scroll = (dir) => {
    if (!scrollRef.current) return;

    const cardWidth = scrollRef.current.firstChild?.offsetWidth || 320;
    scrollRef.current.scrollBy({
      left: dir === "left" ? -cardWidth : cardWidth,
      behavior: "smooth",
    });
  };

  const availableProjects = projects.filter(
    item =>
      item.status === "Under Offer" ||
      item.status === "Available"
  );

  useEffect(() => {
    api.get("real-estate-property")
      .then(res => setProjects(res.data.data || []))
      .catch(err => console.error(err));
  }, []);
  const showArrows =
    isDesktop && availableProjects.length >= 4;
  return (
    <section className="premium-featured-section">
      <div className="premium-featured-header">
        <h2 className="premium-featured-title">
          Featured Properties
        </h2>
      </div>

      <div className="premium-slider-wrapper">
        {showArrows && (
          <button
            className="premium-slider-arrow left"
            onClick={() => scroll("left")}
          >
            &#10094;
          </button>
        )}

        <div className="premium-cards-track" ref={scrollRef}>
          {availableProjects.map((item, i) => (
            <motion.div
              key={i}
              className="premium-property-card"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              whileHover={{ y: -8 }}
              onClick={() =>
                navigate("/properties/details", {
                  state: { propertyData: item }
                })
              }
            >
              <div className="premium-card-media">
                <img
                  src={item?.property_image_url}
                  alt={item?.property_name}
                />
                <span className="premium-status-badge">
                  {item.status}
                </span>
              </div>

              <div className="premium-card-content">
                <h3 className="premium-property-title">
                  {item.property_name}
                </h3>

                <div className="premium-location-price">
                  <span className="premium-location">
                    {item.location}
                  </span>
                  <span className="premium-price">
                    ₹ {item.price}
                  </span>
                </div>

                <div className="premium-divider"></div>

                <div className="premium-features">
                  <span>{item.no_of_beds} Beds</span>
                  <span>{item.no_of_bathroom} Baths</span>
                  <span>{item.plot_size} sqft</span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {showArrows && (
          <button
            className="premium-slider-arrow right"
            onClick={() => scroll("right")}
          >
            &#10095;
          </button>
        )}
      </div>
    </section>
  );
};

export default PremiumFeaturedListings;